function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["id"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); _groups.set(_this, groups || _groups.get(re)); return _setPrototypeOf(_this, BabelRegExp.prototype); } _inherits(BabelRegExp, RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; if (_typeof(args[args.length - 1]) !== "object") { args = [].slice.call(args); args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { renderToString } from 'react-dom/server';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.css';
import FilePondPluginImageEditor from '@pushly/filepond-plugin-image-editor';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';
import { // Image editor
openEditor, appendEditor, processImage, createDefaultImageReader, createDefaultImageWriter, createDefaultImageOrienter, createMarkupEditorToolStyles, createMarkupEditorToolStyle, // The method used to register the plugins
setPlugins, // The plugins we want to use
plugin_crop, plugin_annotate, plugin_sticker, plugin_finetune, plugin_finetune_defaults, plugin_filter, plugin_filter_defaults, markup_editor_defaults, // Only needed if loading legacy image editor data
legacyDataToImageState, // Import the editor default configuration
getEditorDefaults } from '@pushly/pintura';
import '@pushly/pintura/pintura.css';
import { useService } from '../../../../hooks/use-service';
import { FileAddFilled } from '@ant-design/icons';
import { DEFAULT_FILE_TYPES } from '../../contants';
import { FileUploadService } from '../../../../services/file-upload.service';
import aqe from '../../../../stores/aqe';
import { stripUndefined } from '@pushly/aquarium-utils/lib/common/helpers/object';
import randomstring from 'randomstring'; // FilePond Plugins

registerPlugin(FilePondPluginFileValidateType, FilePondPluginImageEditor, FilePondPluginFilePoster); // Pintura Plugins

setPlugins(plugin_crop, plugin_finetune, plugin_filter, plugin_annotate, plugin_sticker);

var DataUrlRgx = /*#__PURE__*/_wrapRegExp(/^data:((?:(?![,;])[\s\S])+)?(?:;?(charset=(?:(?![,;])[\s\S])+))?(?:;base64)?,(.+)/i, {
  mimetype: 1,
  charset: 2,
  data: 3
}); // Filepond currently only supports string values for "labelIdle"
// https://github.com/pqina/react-filepond/issues/111#issuecomment-631186446
//


var getFilepondIdleLabel = function getFilepondIdleLabel() {
  return renderToString( /*#__PURE__*/React.createElement("div", {
    className: "filepond--label-action filepond--label-idle"
  }, /*#__PURE__*/React.createElement("span", {
    className: "filepond--label-action-icon"
  }, /*#__PURE__*/React.createElement(FileAddFilled, null)), /*#__PURE__*/React.createElement("span", {
    className: "filepond--label-action-heading"
  }, "Select Files to Upload"), /*#__PURE__*/React.createElement("span", {
    className: "filepond--label-action-sub-heading"
  }, "or Drag and Drop files")));
};

var getCacheBustedUrl = function getCacheBustedUrl(url) {
  var cbUrl = new URL(url);
  cbUrl.searchParams.append('_cb', randomstring.generate());
  return cbUrl.toString();
};

var getCacheBustedFileUrl = function getCacheBustedFileUrl(url) {
  return fetch(getCacheBustedUrl(url)).then(function (res) {
    return res.blob();
  });
};

var FilePondClient = function FilePondClient(_ref) {
  var _props$type, _props$defaultValue, _propsValue$providerO, _ref2, _propsValue$providerO2, _propsValue$providerO3, _propsValue$providerO4, _propsValue$providerO5, _props$imageConfig$qu, _props$imageConfig, _props$allowedMimeTyp, _props$imageConfig2, _props$imageConfig$cr, _props$imageConfig3, _props$imageConfig$cr2, _props$imageConfig4, _props$imageConfig$cr3, _props$imageConfig5, _props$imageConfig$re, _ref3, _propsValue$providerO6, _props$imageConfig6;

  var id = _ref.id,
      props = _objectWithoutProperties(_ref, _excluded);

  var fileUploadSvc = useService(FileUploadService);
  var pond = React.createRef();
  var editor = React.useRef();
  var fileType = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'image';
  var isImageMode = fileType === 'image';
  var ownerType = props.ownerType === 'org' ? 'account' : 'domain';
  var ownerId = props.ownerId;
  var acl = props["private"] ? 'private' : 'public-read';
  var apiEndpoint = new URL(FileUploadService.endpoint);
  var propsValue = (_props$defaultValue = props.defaultValue) !== null && _props$defaultValue !== void 0 ? _props$defaultValue : props.value;

  var _React$useState = React.useState(isImageMode && !!(propsValue !== null && propsValue !== void 0 && (_propsValue$providerO = propsValue.providerOptions) !== null && _propsValue$providerO !== void 0 && _propsValue$providerO.localMediaSource)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      initEditorOnAdd = _React$useState2[0],
      setInitEditorOnAdd = _React$useState2[1];

  var _React$useState3 = React.useState(!propsValue ? [] : [{
    source: (_ref2 = (_propsValue$providerO2 = (_propsValue$providerO3 = propsValue.providerOptions) === null || _propsValue$providerO3 === void 0 ? void 0 : _propsValue$providerO3.localMediaSource) !== null && _propsValue$providerO2 !== void 0 ? _propsValue$providerO2 : (_propsValue$providerO4 = propsValue.providerOptions) === null || _propsValue$providerO4 === void 0 ? void 0 : _propsValue$providerO4.originalMediaUrl) !== null && _ref2 !== void 0 ? _ref2 : propsValue.url,
    options: {
      type: (_propsValue$providerO5 = propsValue.providerOptions) !== null && _propsValue$providerO5 !== void 0 && _propsValue$providerO5.localMediaSource ? 'local' : 'remote'
    }
  }]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      files = _React$useState4[0],
      setFiles = _React$useState4[1];

  var qualityIntValue = (_props$imageConfig$qu = (_props$imageConfig = props.imageConfig) === null || _props$imageConfig === void 0 ? void 0 : _props$imageConfig.quality) !== null && _props$imageConfig$qu !== void 0 ? _props$imageConfig$qu : 40; // 40 = system default

  var acceptedFileTypes = (_props$allowedMimeTyp = props.allowedMimeTypes) !== null && _props$allowedMimeTyp !== void 0 ? _props$allowedMimeTyp : fileType === 'file' ? DEFAULT_FILE_TYPES.files : DEFAULT_FILE_TYPES.images; // pintura

  var defaultEditorOptions = getEditorDefaults();
  var editorClassName = "".concat(id, "-pintura-editor"); // crop definitions

  var cropAbs = !((_props$imageConfig2 = props.imageConfig) !== null && _props$imageConfig2 !== void 0 && _props$imageConfig2.cropDim) ? undefined : {
    width: props.imageConfig.cropDim[0],
    height: (_props$imageConfig$cr = props.imageConfig.cropDim[1]) !== null && _props$imageConfig$cr !== void 0 ? _props$imageConfig$cr : props.imageConfig.cropDim[0]
  };
  var cropMax = cropAbs !== null && cropAbs !== void 0 ? cropAbs : !((_props$imageConfig3 = props.imageConfig) !== null && _props$imageConfig3 !== void 0 && _props$imageConfig3.cropMax) ? undefined : {
    width: props.imageConfig.cropMax[0],
    height: (_props$imageConfig$cr2 = props.imageConfig.cropMax[1]) !== null && _props$imageConfig$cr2 !== void 0 ? _props$imageConfig$cr2 : props.imageConfig.cropMax[0]
  };
  var cropMin = !((_props$imageConfig4 = props.imageConfig) !== null && _props$imageConfig4 !== void 0 && _props$imageConfig4.cropMin) ? undefined : {
    width: props.imageConfig.cropMin[0],
    height: (_props$imageConfig$cr3 = props.imageConfig.cropMin[1]) !== null && _props$imageConfig$cr3 !== void 0 ? _props$imageConfig$cr3 : props.imageConfig.cropMin[0]
  }; // size definition

  var targetSize = (_props$imageConfig5 = props.imageConfig) !== null && _props$imageConfig5 !== void 0 && _props$imageConfig5.resize ? {
    width: props.imageConfig.resize[0],
    height: (_props$imageConfig$re = props.imageConfig.resize[1]) !== null && _props$imageConfig$re !== void 0 ? _props$imageConfig$re : props.imageConfig.resize[0]
  } : (_ref3 = cropAbs !== null && cropAbs !== void 0 ? cropAbs : cropMax) !== null && _ref3 !== void 0 ? _ref3 : {};
  var editorStickers = ['😄', '👍', '👎', '⭐️', '☀️'];
  /**
   * Adding Image.crossOrigin = 'Anonymous' should
   * fix issues with a known, Chromium only, issue
   * where the first request is cached w/o cors causing
   * all subsequent calls to fail with CORS headers added.
   */

  if (props.ownerIcon) {
    var ownerIcon = new Image();
    ownerIcon.crossOrigin = 'Anonymous';
    ownerIcon.src = getCacheBustedUrl(props.ownerIcon);
    editorStickers.unshift(ownerIcon);
  }

  var removePinturaEditorInstance = React.useCallback(function () {
    var destroy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (editor.current) {
      console.debug('[FilePondProvider] removing PinturaEditor', editor.current);

      if (destroy) {
        editor.current.destroy();
      } else {
        editor.current.close();
      }

      editor.current = undefined;
    }
  }, [editor.current]);
  React.useEffect(function () {
    console.debug('[FilePondClient] allowed file types:', acceptedFileTypes);
    return function () {
      // ensure editor instance removed on unmount
      removePinturaEditorInstance();
    };
  }, []);
  var imageEditorConfig = stripUndefined({
    legacyDataToImageState: legacyDataToImageState,
    createEditor: !props.editorContainerSelector ? openEditor : function (options) {
      return editor.current = appendEditor(props.editorContainerSelector, options);
    },
    imageReader: [createDefaultImageReader],
    imageWriter: [createDefaultImageWriter, {
      targetSize: _objectSpread(_objectSpread({}, targetSize), {}, {
        fit: 'cover',
        upscale: false
      }),
      quality: qualityIntValue / 100
    }],
    imageProcessor: processImage,
    editorOptions: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      "class": editorClassName,
      handleEvent: function handleEvent(type, _detail) {
        switch (type) {
          case 'process':
          case 'close':
            removePinturaEditorInstance(true);
            break;
        }
      },
      imageOrienter: createDefaultImageOrienter(),
      imageState: propsValue === null || propsValue === void 0 ? void 0 : (_propsValue$providerO6 = propsValue.providerOptions) === null || _propsValue$providerO6 === void 0 ? void 0 : _propsValue$providerO6.imageState,
      utils: ['crop', 'finetune', 'filter', 'annotate', 'sticker'],
      imageCropMinSize: cropMin,
      imageCropAspectRatio: (_props$imageConfig6 = props.imageConfig) === null || _props$imageConfig6 === void 0 ? void 0 : _props$imageConfig6.cropRatio,
      cropImageSelectionCornerStyle: 'hook',
      cropEnableButtonFlipVertical: true,
      cropEnableButtonRotateRight: true,
      cropEnableZoomInput: true,
      enableButtonClose: props.platformMode === 'MOBILE'
    }, plugin_finetune_defaults), plugin_filter_defaults), markup_editor_defaults), {}, {
      // markupEditorToolStyles: {
      //     text: defaultEditorOptions.markupEditorToolStyles!.text,
      // },
      // markupEditorToolbar: defaultEditorOptions.markupEditorToolbar!.filter(
      //     tool => ['text'].includes(tool[0])),
      annotateActiveTool: 'text',
      markupEditorToolStyles: createMarkupEditorToolStyles({
        text: createMarkupEditorToolStyle('text', {
          fontSize: '4%'
        })
      }),
      stickerStickToImage: true,
      stickers: editorStickers,
      animations: 'never',
      locale: defaultEditorOptions.locale
    })
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id
  }), /*#__PURE__*/React.createElement(FilePond, {
    ref: pond,
    id: id,
    name: "file",
    files: files,
    allowMultiple: false,
    maxFiles: 1,
    instantUpload: true,
    labelIdle: getFilepondIdleLabel(),
    server: {
      url: FileUploadService.endpoint,
      // custom fetch hadnler for remote urls proxied through pushly s3
      fetch: function fetch(url, load, _error, _progress, abort) {
        var fetchEndpoint = new URL(apiEndpoint.toString());
        fetchEndpoint.searchParams.append('fetch', url);
        var fetchHandler;

        if (url.includes(aqe.defaults.publicMediaDomain)) {
          fetchHandler = getCacheBustedFileUrl(url);
        } else {
          fetchHandler = fileUploadSvc.fetchRemoteSource(url).then(function (res) {
            if (!res.ok) {
              var _error$response;

              var error = res.error;
              var details = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;

              if ((details === null || details === void 0 ? void 0 : details.status_code) === 400 && (details === null || details === void 0 ? void 0 : details.error_type) === 'invalid_file_type_error') {
                var _props$onError;

                (_props$onError = props.onError) === null || _props$onError === void 0 ? void 0 : _props$onError.call(props, {
                  error: details
                });
              } else {
                throw res.error;
              }
            }

            return getCacheBustedFileUrl(res.data.url).then(function (blob) {
              return {
                blob: blob,
                metadata: res.data
              };
            });
          }).then(function (res) {
            var workingFile = files.find(function (f) {
              return f.source === url;
            });

            if (workingFile !== null && workingFile !== void 0 && workingFile.options) {
              workingFile.options.serverId = res.metadata.handle;
            }

            return res.blob;
          });
        }

        fetchHandler.then(function (blob) {
          return load(blob);
        })["catch"](function (err) {
          console.warn('[FilePondClient] fetch error', err);
          abort();
        });
        return {
          abort: abort
        };
      },
      // send processed/transformed uploads to api
      process: function () {
        var _process = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fieldName, file, metadata, load, error, progress, abort) {
          var workingFile, _workingFile$options, _props$imageConfig7, _props$onChange, _props$onSuccess, res, resPack;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  workingFile = files[0];
                  _context.prev = 1;
                  _context.next = 4;
                  return fileUploadSvc.processFormDataUpload(fileType, ownerType, ownerId, fieldName, file, acl, stripUndefined({
                    tmpId: workingFile === null || workingFile === void 0 ? void 0 : (_workingFile$options = workingFile.options) === null || _workingFile$options === void 0 ? void 0 : _workingFile$options.serverId,
                    originalMediaUrl: metadata === null || metadata === void 0 ? void 0 : metadata.originalMediaUrl,
                    quality: isImageMode ? qualityIntValue : undefined,
                    progressive: isImageMode && ((_props$imageConfig7 = props.imageConfig) === null || _props$imageConfig7 === void 0 ? void 0 : _props$imageConfig7.pjpg)
                  }), function (ev) {
                    progress(ev.lengthComputable, ev.loaded, ev.total);
                  });

                case 4:
                  res = _context.sent;
                  load(res.url);
                  resPack = _objectSpread(_objectSpread({}, res), {}, {
                    providerOptions: metadata
                  });
                  (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, resPack);
                  (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, resPack);
                  _context.next = 15;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](1);

                  if (_context.t0 instanceof XMLHttpRequest) {
                    console.warn('[FilePondClient] error', _context.t0.status);
                  }

                  throw _context.t0;

                case 15:
                  return _context.abrupt("return", {
                    abort: abort
                  });

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 11]]);
        }));

        function process(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
          return _process.apply(this, arguments);
        }

        return process;
      }(),
      // delete requests blocked to prevent removing previosuly used media references
      revert: function revert(_fileHandle, load, _error) {
        return load();
      }
    } // @ts-ignore -- missing method type definition
    ,
    oninitfile: function oninitfile(file) {
      var isUrlSource = typeof file.source === 'string';
      var isDataUrl = isUrlSource && DataUrlRgx.test(file.source);

      if (isUrlSource && !isDataUrl) {
        file.setMetadata('originalMediaUrl', file.source, true);
      } else {
        file.setMetadata('originalMediaUrl', file.filename, true);

        if (isImageMode) {
          file.setMetadata('localMediaSource', file.source, true);
        }
      }
    } // if initEditorOnAdd is set the editor is invoked on add
    ,
    onaddfile: function onaddfile(err, file) {
      if (initEditorOnAdd) {
        var _edit, _ref4;

        (_edit = (_ref4 = file).edit) === null || _edit === void 0 ? void 0 : _edit.call(_ref4);
        setInitEditorOnAdd(false);
      }

      if (isImageMode && file.file && !file.getMetadata('localMediaSource')) {
        file.setMetadata('localMediaSource', file.file);
      }
    },
    onupdatefiles: function onupdatefiles(updatedFiles) {
      setFiles(updatedFiles);

      if (!updatedFiles.length && props.onEmpty) {
        props.onEmpty();
      }
    } // FilePondPluginFileValidateType
    ,
    allowFileTypeValidation: true,
    acceptedFileTypes: acceptedFileTypes,
    fileValidateTypeDetectType: function fileValidateTypeDetectType(source, type) {
      return new Promise(function (res, rej) {
        var file = source;
        var valid = false;

        if (acceptedFileTypes.length === 1 && acceptedFileTypes[0] === DEFAULT_FILE_TYPES.pkcs8[0]) {
          if (!file.type) {
            var p8Regex = /^.*\.(p8)/ig;
            valid = p8Regex.test(file.name);
          }

          if (valid) {
            res(DEFAULT_FILE_TYPES.pkcs8[0]);
          } else {
            rej('Invalid file type.');
          }
        }

        res(type);
      });
    } // FilePondPluginFilePoster Integration
    ,
    filePosterMaxHeight: 64 // FilePondPluginImageEditor Integration
    ,
    imageEditorInstantEdit: isImageMode ? true : undefined // stripUndefined fixes strange bug with undefined values
    // causing the editor to hang on open
    ,
    imageEditor: isImageMode ? imageEditorConfig : undefined
  }));
};

export default FilePondClient;